var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoverBackground01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1440 960",
    preserveAspectRatio: "none meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t.s0{\n\t\tfill: #fff;\n\t}\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6 {\n        fill: none;\n      }\n\n      .st7, .st8 {\n        fill: #d6d6d6;\n      }\n\n      .st7, .st8, .st9, .st2, .st10, .st3, .st4, .st5, .st6, .st11 {\n        isolation: isolate;\n      }\n\n      .st7, .st8, .st2, .st12, .st4, .st5 {\n        opacity: .8;\n      }\n\n      .st8, .st9 {\n        fill-rule: evenodd;\n      }\n\n      .st9, .st3, .st6, .st11 {\n        opacity: .2;\n      }\n\n      .st9, .st11 {\n        fill: #fff;\n      }\n\n      .st1, .st2, .st3, .st4, .st5, .st6 {\n        stroke-miterlimit: 19.2;\n      }\n\n      .st1, .st3 {\n        stroke: #fff;\n      }\n\n      .st1, .st4 {\n        stroke-width: .6px;\n      }\n\n      .st2 {\n        stroke: #d6d6d6;\n      }\n\n      .st2, .st6 {\n        stroke-width: 1.5px;\n      }\n\n      .st10 {\n        fill: #ccc;\n        opacity: .1;\n      }\n\n      .st3 {\n        stroke-width: 1.2px;\n      }\n\n      .st4, .st5, .st6 {\n        stroke: #999b95;\n      }\n\n      .st5 {\n        stroke-width: 1px;\t\n      }\n\n      .st13 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1440,
    height: 960
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "M1440 0v960H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_",
    className: "st10",
    d: "M1440,0v960H265.2L1225.2,0h214.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_1",
    "data-name": "_x3C_Path_x3E_",
    className: "st10",
    d: "M1440,366.5v593.5h-593.5l593.5-593.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_2",
    "data-name": "_x3C_Path_x3E_",
    className: "st10",
    d: "M469.8,0L0,469.8V0h469.8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Clip_Group_x3E_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_3",
    "data-name": "_x3C_Path_x3E_",
    className: "st6",
    d: "M1640.8,320.4l-296.3,296.3c-14,14-37.1,14-51.1,0-14.2-14.2-14.2-37.1,0-51.3l296.1-296.1c14.2-14.2,37.1-14.2,51.3,0,14,14,14,37.1,0,51.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_4",
    "data-name": "_x3C_Path_x3E_",
    className: "st3",
    d: "M1564-100l-218.1,218.1c-10.4,10.4-27.3,10.4-37.6,0-10.4-10.6-10.4-27.5,0-37.8l218.1-218.1c10.4-10.4,27.3-10.4,37.6,0,10.4,10.4,10.4,27.3,0,37.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_5",
    "data-name": "_x3C_Path_x3E_",
    className: "st6",
    d: "M413-212.7L116.9,83.5c-14.2,14-37.2,14-51.3,0-14.2-14.2-14.2-37.1,0-51.3l296.1-296.1c14.2-14.2,37.1-14.2,51.3,0,14.2,14,14.2,37.1,0,51.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_6",
    "data-name": "_x3C_Path_x3E_",
    className: "st6",
    d: "M237.9,495.6L-58.2,791.6c-14.2,14.2-37.1,14.2-51.3,0-14-14-14-37.1,0-51.1L186.8,444.3c14-14,37.1-14,51.1,0,14.2,14.2,14.2,37.1,0,51.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_7",
    "data-name": "_x3C_Path_x3E_",
    className: "st11",
    d: "M1534.8,294.1l-240.4,240.4c-6.1,6.1-15.9,6.1-21.9,0-6.1-6-6.1-15.7,0-21.9l240.4-240.4c6-6,15.7-6,21.9,0,6,6,6,15.7,0,21.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_8",
    "data-name": "_x3C_Path_x3E_",
    className: "st11",
    d: "M389.6-167.6L149.2,72.8c-6.1,6-15.9,6-21.9,0s-6.1-15.9,0-21.9l240.4-240.4c6-6.1,15.7-6.1,21.9,0,6,6,6,15.7,0,21.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_9",
    "data-name": "_x3C_Path_x3E_",
    className: "st11",
    d: "M152.1,655.7l-240.6,240.6c-6,6-15.7,6-21.7,0v-.2c-6.1-6-6.1-15.7,0-21.7l240.4-240.6c6-6,15.7-6,21.9,0,6,6.1,6,15.9,0,21.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Compound_Path_x3E_",
    className: "st11",
    d: "M1271.4,832.7c-91,0-164.7,73.7-164.7,164.7s73.7,164.9,164.7,164.9,164.9-73.9,164.9-164.9-73.7-164.7-164.9-164.7ZM1271.4,1137.6c-77.2,0-140-62.8-140-140.2s62.8-140,140-140,140.2,62.8,140.2,140-62.8,140.2-140.2,140.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Compound_Path_x3E_1",
    "data-name": "_x3C_Compound_Path_x3E_",
    className: "st11",
    d: "M1154.1-172.2c-51.1-50.9-133.6-50.9-184.7,0-50.9,50.9-50.9,133.6,0,184.5,51.1,51.1,133.6,51.1,184.7,0,50.9-50.9,50.9-133.6,0-184.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Compound_Path_x3E_2",
    "data-name": "_x3C_Compound_Path_x3E_",
    className: "st9",
    d: "M171.5,1127.8c64.3,64.3,168.8,64.3,233.1,0,64.5-64.3,64.5-168.8,0-233.1-64.3-64.3-168.8-64.3-233.1,0s-64.3,168.8,0,233.1h0ZM387.1,912.2c54.7,54.7,54.7,143.4,0,198.1-54.7,54.5-143.4,54.5-198.1,0-54.5-54.7-54.5-143.4,0-198.1,54.7-54.5,143.4-54.5,198.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Compound_Path_x3E_3",
    "data-name": "_x3C_Compound_Path_x3E_",
    className: "st11",
    d: "M612.5-241c-91.2,0-164.9,73.9-164.9,164.9s73.7,164.9,164.9,164.9,164.7-73.9,164.7-164.9-73.7-164.9-164.7-164.9ZM612.5,63.9c-77.4,0-140.2-62.6-140.2-140s62.8-140,140.2-140,140,62.6,140,140-62.8,140-140,140Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_1",
    "data-name": "_x3C_Group_x3E_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_10",
    "data-name": "_x3C_Path_x3E_",
    className: "st1",
    d: "M1706.1,377.3c0,120.8-97.9,218.7-218.7,218.7s-218.7-97.9-218.7-218.7,97.9-218.7,218.7-218.7,218.7,97.9,218.7,218.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_11",
    "data-name": "_x3C_Path_x3E_",
    className: "st1",
    d: "M1692.7,377.3c0,113.5-92,205.2-205.2,205.2s-205.2-91.8-205.2-205.2,91.8-205.2,205.2-205.2,205.2,92,205.2,205.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_12",
    "data-name": "_x3C_Path_x3E_",
    className: "st1",
    d: "M1679.2,377.3c0,106-85.8,191.8-191.8,191.8s-191.8-85.8-191.8-191.8,85.8-191.8,191.8-191.8,191.8,85.8,191.8,191.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_13",
    "data-name": "_x3C_Path_x3E_",
    className: "st1",
    d: "M1665.8,377.3c0,98.5-79.9,178.4-178.4,178.4s-178.4-79.9-178.4-178.4,79.9-178.4,178.4-178.4,178.4,79.9,178.4,178.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_14",
    "data-name": "_x3C_Path_x3E_",
    className: "st1",
    d: "M1652.4,377.3c0,91.2-73.9,164.9-164.9,164.9s-164.9-73.7-164.9-164.9,73.7-164.9,164.9-164.9,164.9,73.9,164.9,164.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_15",
    "data-name": "_x3C_Path_x3E_",
    className: "st1",
    d: "M1638.9,377.3c0,83.7-67.8,151.5-151.5,151.5s-151.5-67.8-151.5-151.5,67.8-151.5,151.5-151.5,151.5,67.8,151.5,151.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_2",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_16",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M136.5,346.8c0,116.9-94.7,211.6-211.6,211.6s-211.6-94.7-211.6-211.6,94.8-211.6,211.6-211.6,211.6,94.8,211.6,211.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_17",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M123.5,346.8c0,109.6-88.9,198.5-198.5,198.5s-198.5-88.9-198.5-198.5,88.9-198.5,198.5-198.5,198.5,88.9,198.5,198.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_18",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M110.6,346.8c0,102.5-83.1,185.7-185.7,185.7s-185.5-83.1-185.5-185.7,82.9-185.5,185.5-185.5,185.7,83.1,185.7,185.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_19",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M97.5,346.8c0,95.4-77.2,172.6-172.6,172.6s-172.6-77.2-172.6-172.6,77.4-172.4,172.6-172.4,172.6,77.2,172.6,172.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_20",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M84.5,346.8c0,88.1-71.4,159.6-159.6,159.6s-159.6-71.4-159.6-159.6,71.4-159.6,159.6-159.6,159.6,71.4,159.6,159.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_21",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M71.6,346.8c0,81-65.7,146.7-146.7,146.7s-146.5-65.7-146.5-146.7,65.7-146.5,146.5-146.5,146.7,65.7,146.7,146.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_3",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_22",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M1192.3,1010.9c0,65.3-53,118.3-118.3,118.3s-118.1-53-118.1-118.3,52.8-118.1,118.1-118.1,118.3,52.8,118.3,118.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_23",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M1174.1,1010.9c0,55.3-44.7,100-100,100s-100-44.7-100-100,44.7-100,100-100,100,44.9,100,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_24",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M1156,1010.9c0,45.3-36.7,82-82,82s-81.8-36.7-81.8-82,36.7-81.8,81.8-81.8,82,36.7,82,81.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_4",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_25",
    "data-name": "_x3C_Path_x3E_",
    className: "st5",
    d: "M958.1,1062.9c0,116.7-94.8,211.4-211.6,211.4s-211.6-94.7-211.6-211.4,94.7-211.6,211.6-211.6,211.6,94.7,211.6,211.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_26",
    "data-name": "_x3C_Path_x3E_",
    className: "st5",
    d: "M936.4,1062.9c0,104.8-85.1,189.9-189.9,189.9s-189.9-85.1-189.9-189.9,85.1-189.9,189.9-189.9,189.9,84.9,189.9,189.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_27",
    "data-name": "_x3C_Path_x3E_",
    className: "st5",
    d: "M914.7,1062.9c0,92.7-75.3,168.2-168.2,168.2s-168.2-75.5-168.2-168.2,75.3-168.4,168.2-168.4,168.2,75.5,168.2,168.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_28",
    "data-name": "_x3C_Path_x3E_",
    className: "st5",
    d: "M893,1062.9c0,80.8-65.5,146.5-146.5,146.5s-146.5-65.7-146.5-146.5,65.5-146.7,146.5-146.7,146.5,65.7,146.5,146.7h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_5",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_29",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M349.4-51.3c0,65.3-53,118.3-118.3,118.3S113.1,14,113.1-51.3s52.8-118.3,118.1-118.3,118.3,53,118.3,118.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_30",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M331.2-51.3c0,55.3-44.7,100-100,100S131.1,4,131.1-51.3s44.7-100,100-100,100,44.7,100,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_31",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M313.2-51.3c0,45.3-36.7,82-82,82S149.4-6,149.4-51.3s36.7-81.8,81.8-81.8,82,36.5,82,81.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_6",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_32",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M1336.5-51.3c0,70.8-57.4,128.3-128.1,128.3s-128.3-57.4-128.3-128.3,57.4-128.3,128.3-128.3,128.1,57.4,128.1,128.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_33",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M1316.9-51.3c0,59.9-48.6,108.5-108.5,108.5s-108.5-48.6-108.5-108.5,48.6-108.5,108.5-108.5,108.5,48.6,108.5,108.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_34",
    "data-name": "_x3C_Path_x3E_",
    className: "st4",
    d: "M1297.2-51.3c0,49.2-39.7,88.9-88.7,88.9s-88.9-39.7-88.9-88.9,39.7-88.7,88.9-88.7,88.7,39.7,88.7,88.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_7",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_35",
    "data-name": "_x3C_Path_x3E_",
    className: "st2",
    d: "M-132.5,1092.5l296.1-296.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_36",
    "data-name": "_x3C_Path_x3E_",
    className: "st7",
    d: "M166.8,796.4c0,1.7-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3,1.5-3.3,3.3-3.3,3.3,1.5,3.3,3.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_8",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_37",
    "data-name": "_x3C_Path_x3E_",
    className: "st2",
    d: "M-156.3,524.2L139.8,227.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_38",
    "data-name": "_x3C_Path_x3E_",
    className: "st7",
    d: "M143,227.9c0,1.9-1.5,3.3-3.3,3.3s-3.1-1.3-3.1-3.3,1.3-3.1,3.1-3.1,3.3,1.3,3.3,3.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_9",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_39",
    "data-name": "_x3C_Path_x3E_",
    className: "st2",
    d: "M731.1-211.4L434.9,84.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_40",
    "data-name": "_x3C_Path_x3E_",
    className: "st8",
    d: "M434.9,87.9c-1.7,0-3.1-1.3-3.1-3.1s1.3-3.3,3.1-3.3,3.3,1.3,3.3,3.3-1.5,3.1-3.3,3.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_10",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_41",
    "data-name": "_x3C_Path_x3E_",
    className: "st2",
    d: "M379.6,112.5l296.3-296.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_42",
    "data-name": "_x3C_Path_x3E_",
    className: "st8",
    d: "M379.6,115.8c-1.7,0-3.1-1.3-3.1-3.3s1.3-3.1,3.1-3.1,3.3,1.3,3.3,3.1-1.3,3.3-3.3,3.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_11",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_43",
    "data-name": "_x3C_Path_x3E_",
    className: "st2",
    d: "M1087.1,1165.1l296.1-296.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_44",
    "data-name": "_x3C_Path_x3E_",
    className: "st7",
    d: "M1386.4,869c0,1.7-1.5,3.1-3.3,3.1s-3.1-1.3-3.1-3.1,1.3-3.3,3.1-3.3,3.3,1.5,3.3,3.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_12",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_45",
    "data-name": "_x3C_Path_x3E_",
    className: "st2",
    d: "M1570.2-67.2l-296.1,296.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_46",
    "data-name": "_x3C_Path_x3E_",
    className: "st7",
    d: "M1270.8,228.9c0-1.7,1.5-3.1,3.3-3.1s3.3,1.3,3.3,3.1-1.5,3.3-3.3,3.3-3.3-1.3-3.3-3.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_13",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_47",
    "data-name": "_x3C_Path_x3E_",
    className: "st2",
    d: "M1443.1-250.9l-398.8,398.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_48",
    "data-name": "_x3C_Path_x3E_",
    className: "st8",
    d: "M1041,147.8c0-1.7,1.5-3.1,3.3-3.1s3.1,1.3,3.1,3.1-1.3,3.3-3.1,3.3-3.3-1.3-3.3-3.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_14",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_49",
    "data-name": "_x3C_Path_x3E_",
    className: "st2",
    d: "M134.8,1217.3l398.8-398.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_50",
    "data-name": "_x3C_Path_x3E_",
    className: "st7",
    d: "M536.6,818.5c0,1.9-1.3,3.3-3.1,3.3s-3.3-1.3-3.3-3.3,1.5-3.1,3.3-3.1,3.1,1.3,3.1,3.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_15",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_51",
    "data-name": "_x3C_Path_x3E_",
    className: "st2",
    d: "M676.2,1098.2l296.3-296.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_52",
    "data-name": "_x3C_Path_x3E_",
    className: "st7",
    d: "M975.6,802c0,1.7-1.3,3.3-3.1,3.3s-3.3-1.5-3.3-3.3,1.3-3.1,3.3-3.1,3.1,1.3,3.1,3.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E_16",
    "data-name": "_x3C_Group_x3E_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_53",
    "data-name": "_x3C_Path_x3E_",
    className: "st2",
    d: "M596.5,1150.5l296.1-296.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_54",
    "data-name": "_x3C_Path_x3E_",
    className: "st7",
    d: "M895.9,854.4c0,1.7-1.3,3.1-3.3,3.1s-3.1-1.3-3.1-3.1,1.3-3.3,3.1-3.3,3.3,1.5,3.3,3.3Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverBackground01);
export default __webpack_public_path__ + "static/media/cover_background_01.e54f74cd7efeec1aa806ddfb55f81512.svg";
export { ForwardRef as ReactComponent };